import type { FeedbackMessages } from './en';

const pt: FeedbackMessages = {
  qualified: {
    title: 'Obrigado por concluir este estudo!',
    body1: 'Já pode fechar a janela do navegador.',
    body2: 'Esperamos vê-lo novamente em breve.',
    refCode: 'Código de referência: {code}',
  },
  quotaFull: {
    title: 'Este estudo está encerrado',
    body1: 'Obrigado pelo seu interesse no nosso estudo.',
    body2: 'Infelizmente, já recebemos todas as respostas de que precisávamos.',
    body3: 'Esperamos vê-lo num dos nossos futuros estudos!',
    refCode: 'Código de referência: {code}',
  },
  terminated: {
    title: 'Obrigado por compartilhar o seu feedback!',
    body1:
      'Esperamos vê-lo em breve nos nossos futuros estudos. Até então, desejamos-lhe um ótimo dia.',
    body2: 'Por favor, feche esta janela do navegador.',
    refCode: 'Código de referência: {code}',
  },
  mismatch: {
    title: 'Obrigado pelo seu interesse',
    body1: 'Infelizmente, não pertence ao público-alvo deste estudo específico.',
    body2: 'Pode fechar esta página.',
    code: 'Código: {code}',
  },
  error: {
    title: 'Não conseguimos processar o seu pedido',
    linkProblemDetailed:
      'O link que seguiu está com problemas. Verifique se o link na barra de endereço corresponde ao que lhe foi fornecido e tente novamente.',
    linkProblemGeneric: 'O link que seguiu está com problemas. Tente novamente, por favor.',
    contactPerson:
      'Se o problema persistir, informe a pessoa que lhe enviou o link sobre este problema.',
    errorCode: 'Código de erro: {code}',
  },
};

export default pt;
